// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"95":"2d0aa9f74c3a5223","696":"ce22414064ec9b02"}[chunkId] + ".css";
};